<template>
  <div class="candidates__container">
    <div
      class="candidates__content"
      :class="{ 'candidates__content--blurred': isExpired }"
    >
      <CandidatesTable :statuses="statuses" />
    </div>
    <div
      v-if="isExpired"
      class="candidates__tariff-overlay"
    >
      <VCard class="candidates__tariff-card">
        <VCardTitle class="candidates__tariff-header">
          <img
            :src="require('@/assets/img/tarrif-change-warning.svg')"
            alt=""
            class="candidates__tariff-icon"
          >
          <div class="candidates__tariff-title">
            {{ $t('tariffInactiveTitle') }}
          </div>
        </VCardTitle>
        <VCardText class="candidates__tariff-text">
          {{ $t('tariffInactiveText') }}
        </VCardText>
        <VBtn
          class="candidates__tariff-btn"
          color="success"
          @click="redirectToUpgradePlan"
        >
          {{ $t('tariffInactiveButton') }}
        </VBtn>
      </VCard>
    </div>
  </div>
</template>

<script>

import { ref, onMounted } from '@vue/composition-api';
import CandidatesTable from '@/components/Candidate/CandidatesTable';
import PageTitle from '@/components/PageTitle';
import useStatus from '@/compositions/useStatus';
import useSubscription from '@/compositions/accounting/useSubscription';
import useScrollLock from '@/compositions/useScrollLock';
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'Candidates',
  metaInfo() {
    return {
      title: this.$t('candidates'),
    };
  },
  components: { PageTitle, CandidatesTable },
  setup(props, { root }) {
    const tab = ref('candidates');
    const { fetchAllStatuses, statuses } = useStatus();
    const { isExpired } = useSubscription();

    useScrollLock(isExpired);

    onMounted(async () => {
      await fetchAllStatuses();
    });

    function redirectToUpgradePlan() {
      root.$router.push({
        name: 'settings',
        params: { type: settingsTabs.PAYMENT, addType: paymentTabs.INFO },
      });
    }

    return {
      tab,
      statuses,
      isExpired,
      redirectToUpgradePlan,
    };
  },
};
</script>

<style lang="scss" scoped>
.candidates {
  &__container {
    height: 100%;
    position: relative;
  }

  &__content--blurred {
    filter: blur(4px);
    pointer-events: none;
    user-select: none;
  }

  &__tariff-overlay {
    position: absolute;
    top: -48px;
    left: -48px;
    right: -48px;
    bottom: -48px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    background: rgba(0, 0, 0, 0.55);
  }

  &__tariff-card {
    max-width: 400px;
    width: 100%;
    padding: 30px;
    border-radius: 8px;
  }

  &__tariff-header {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 0;
    margin-bottom: 8px;
  }

  &__tariff-icon {
    padding: 13px;
    background: rgba(234, 13, 13, 0.1);
    border-radius: 50%;
    margin-bottom: 20px;
  }

  &__tariff-title {
    font-weight: 400;
    font-size: 24px;
    line-height: 26px;
    color: #212121;
  }

  &__tariff-text {
    padding: 0;
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 19.6px;
    font-weight: 300;
    color: #212121;
  }

  &__tariff-btn {
    width: 100%;
    font-weight: 400;
    font-size: 16px;
  }
}
</style>

<i18n locale="ru" lang="yaml">
  candidates: Кандидаты
  tariffInactiveTitle: Тариф закончился
  tariffInactiveText: Для получения доступа к функциям Вашего тарифа необходимо внести оплату.
  tariffInactiveButton: Оплатить тариф
</i18n>

<i18n locale="en" lang="yaml">
  candidates: Candidates
  tariffInactiveTitle: Your tariff is inactive.
  tariffInactiveText: To gain access to all the functions of your tariff, you need to make a payment.
  tariffInactiveButton: Upgrade plan
</i18n>
